import actionCreatorFactory from 'typescript-fsa';

const actionCreator = actionCreatorFactory('PATIENTSIDEBAR/ERROR');

const actions = {
  setError: actionCreator<string | undefined>('toggleError'),
};

export default { ...actions };
